// src/components/ContactCard/ContactCard.js
import React from "react";
import "./ContactCard.css";

const ContactCard = ({ icon, title, description, buttonText, buttonLink, onClick }) => {
  return (
    <div className="contact-card">
      <div className="contact-icon">{icon}</div>
      <h3 className="contact-title">{title}</h3>
      <p className="contact-description">{description}</p>
      {buttonText && (
        buttonLink ? (
          <a href={buttonLink} className="card-button" target="_blank" rel="noopener noreferrer">
            {buttonText}
          </a>
        ) : (
          <button className="card-button" onClick={onClick}>
            {buttonText}
          </button>
        )
      )}
    </div>
  );
};

export default ContactCard;
